import {QueryClient, VueQueryPlugin} from '@tanstack/vue-query';

export default defineNuxtPlugin(nuxtApp => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000, // 1 minute
      },
    },
  });

  nuxtApp.vueApp.use(VueQueryPlugin, {queryClient});
});
